var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-376 -61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V10.667L8,5.333Z",
    transform: "translate(385.143 67.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1.5A10.5,10.5,0,1,1,1.5,12,10.512,10.512,0,0,1,12,1.5M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z",
    transform: "translate(376 61)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play-circle.95b5c1fc1663ad494ed54271c1c2ea17.svg";